import { DatePickerConfig } from 'pages/autorization-payments';
import { fieldsGeneralDataContract } from 'pages/detailed-consultation/helpers/fieldsGeneralDataContract'
import React, { useEffect, useState } from 'react'
import { IContract } from 'shared/api/services';
import { buildDatePickerRange } from 'shared/utils/helpers/buildDatePickerRange';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import Swal from 'sweetalert2';
import { putData } from 'shared/api/services/putData';
import { GET_CONTACT_NUMBER } from 'shared';

export const useEditContract = (data: IContract, setIsEditing: React.Dispatch<React.SetStateAction<boolean>>, idContract?:string) => {
    const [dataFields, setDataFields] = useState<any[]>([]);
    const [contractDateAt, setContractDateAt] = useState<any[]>([null,null]);
    const [isLoading, setIsLoading] = useState(false);
    
    const [startContractDateAt, endContractDateAt] = contractDateAt;
    const getDatePickerConfig = (): DatePickerConfig => ({
        contractDateService: buildDatePickerRange(startContractDateAt, endContractDateAt),
    });

    const getValueDatePickerStart = (name: keyof DatePickerConfig): Date | null => getDatePickerConfig()[name]!.start();
    const getValueDatePickerEnd = (name: keyof DatePickerConfig): Date | null => getDatePickerConfig()[name]!.end();
    const maxDate = (name: keyof DatePickerConfig): Date => getDatePickerConfig()[name]!.max();

    const onChangesDatePicker = ( update:any) => {
        setContractDateAt(update);
    }

    const buildUrl = (valuesUrl:any) => {
        const url = ``;
        const params = {
            contractNumber: valuesUrl.contractNumber.toString(),
            employerIdNumber: valuesUrl.nitEntidad,
            contractStartAt: startContractDateAt ? dayjs.utc(startContractDateAt).format('YYYY-MM-DD') : '',
            contractEndAt: endContractDateAt ? dayjs.utc(endContractDateAt).format('YYYY-MM-DD') : '',
            statusContract: valuesUrl.statusContract,
            contractObject: valuesUrl.contractObject,
            totalValue: valuesUrl.totalValue,
            providerName: valuesUrl.providerName,
            cdpNumber: valuesUrl.cdpNumber,
            auditorName: valuesUrl.auditorName,
            stateId: valuesUrl.contractStatus
        }
        return {params, url}
    }

    const { handleChange, handleSubmit, values } = useFormik({
        initialValues: {
            contractNumber: data?.contractNumber ?? '',
            nitEntidad: data?.provider.employerIdNumber ?? '',
            totalValue: data?.totalValue ?? '',
            providerName: data?.provider.name ?? '',
            cdpNumber: data?.cdpNumber ?? '',
            auditorName: data?.auditorName ?? '',
            contractStatus: data?.state.id ?? '',
            contractObject: data?.contractObject ?? '',
        },
        onSubmit: (vls) => {
            setIsLoading(true);
            if(validateAllFields()){
                const result = buildUrl(vls);
                putData(`${GET_CONTACT_NUMBER}/${idContract}`, { ...result.params }).then(()=>{
                    Swal.fire({
                        icon: 'success',
                        title: 'Contrato actualizado',
                        text: 'El contrato ha sido actualizado exitosamente.',
                        confirmButtonText: 'Aceptar'
                    });
                    setIsEditing(false);
                }).finally(() => setIsLoading(false));
            }
        },
        validateOnChange: false,
        enableReinitialize: true,
    })

    const validateAllFields = () => {
        const missingFields = Object.entries(values).filter(([_, value]) => !value || value === '');
        const missingDates = !startContractDateAt || !endContractDateAt;
        if (missingFields.length > 0 || missingDates) {
            Swal.fire({
                icon: 'error',
                title: 'Campos incompletos',
                text: 'Todos los campos deben estar diligenciados.',
            });
            return false;
        }
        return true;
    };

    useEffect(() => {
        setDataFields(fieldsGeneralDataContract(data, idContract).filter(item  => ![ 'contractStartDateService', 'contractEndDateService', 'contractBalance'].includes(item.name)))
    }, [])

    useEffect(() => {
      if(!data) return;    
      const [year, month, day] = data.contractStartAt.split("-").map(Number);
      const [yearEnd, monthEnd, dayEnd] = data.contractEndAt.split("-").map(Number);

      setContractDateAt([new Date(year, month - 1, day) ?? null, new Date(yearEnd, monthEnd - 1, dayEnd) ?? null]);
    }, [data])
    

  return {
    dataFields,
    values,
    getDatePickerConfig,
    getValueDatePickerStart,
    getValueDatePickerEnd,
    maxDate,
    onChangesDatePicker,
    handleSubmit,
    handleChange,
    loading: isLoading
  }
}
